import { render, staticRenderFns } from "./DocumentPrintedModal.vue?vue&type=template&id=81bd6918&scoped=true&"
import script from "./DocumentPrintedModal.vue?vue&type=script&lang=js&"
export * from "./DocumentPrintedModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPrintedModal.vue?vue&type=style&index=0&id=81bd6918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bd6918",
  null
  
)

export default component.exports